import ReactDOM from "react-dom/client"; // ✅ required for replaceHydrateFunction
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.min.js";
import "./src/assets/css/typography.css";
import "./src/assets/css/global.css";


export const onRouteUpdate = () => {
  window.scrollTo(0, 0);
};